import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchData = createAsyncThunk(
  "fetchData",
  async ({ course, difficulty, categories }) => {
    const apiUrl = `${process.env.REACT_APP_BACKEND_ORIGIN}/api/v1/question?category=${categories}&courseName=${course}&difficultyLevel=${difficulty.toLowerCase()}`
    try {
      const response = await axios.get(apiUrl);
      return response.data; 
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);


const questionSlice = createSlice({
  name: "questions",
  initialState: {
    isLoading: false,
    data: null,
    error: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    });
    builder.addCase(fetchData.rejected, (state, action) => {
      console.log("Error:", action.error);
      state.isLoading = false;
      state.error = true;
      state.data = null;
    });
  },
});

export default questionSlice.reducer;
